import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { formatDate, toUTCAndFormat } from '@utils/dates/date.utils';

// Constants

import { DATE_FORMATS } from '@utils/dates/dateMethods';


const MedicaidTerminationDetailsInfo = props => {

    const {
        DATE_FORMAT
    } = DATE_FORMATS;

    const {
        applyingForCoverageIndicator,
        exchangeAndProgramNames,
        idx,
        householdIncomeOrSizeChanged,
        medicaidChipExpirationDate,
        medicaidTermination,
        medicaidTerminationFeatureEnabled
    } = props;

    const intl = useIntl();

    if(!medicaidTerminationFeatureEnabled) {
        return null;
    }

    if(!applyingForCoverageIndicator) {
        return null;
    }

    // We might expect values to be undefined on previous SSAP applications, so we need to secure them
    const secureValue = value => {
        if(value === undefined) return null;
        return value;
    };

    const getMedicaidChipExpirationDate = date => {
        const securedDate = secureValue(date);
        return formatDate(securedDate, DATE_FORMAT) === 'Invalid Date'
            ? intl.formatMessage({ id: 'common.not_available' })
            : toUTCAndFormat(securedDate, DATE_FORMAT);
    };

    return (
        <Fragment>
            <SummaryItem
                textCode = 'common.medicaid_termination'
                replacements = { exchangeAndProgramNames }
                value = { medicaidTermination }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].medicaidTermination`,
                            secureValue
                        ]
                    ]
                }
            />
            {
                medicaidTermination
                    ? (
                        <Fragment>
                            <SummaryItem
                                textCode = 'common.medicaid_last_day'
                                replacements = { exchangeAndProgramNames }
                                value = { getMedicaidChipExpirationDate(medicaidChipExpirationDate) }
                                ignoreIntl
                                desc = {
                                    [
                                        [
                                            `taxHousehold.householdMember[${ idx }].medicaidChipExpirationDate`,
                                            getMedicaidChipExpirationDate
                                        ]
                                    ]
                                }
                            />
                            <SummaryItem
                                textCode = 'common.income_or_household_size_changed'
                                value = { householdIncomeOrSizeChanged }
                                desc = {
                                    [
                                        [
                                            `taxHousehold.householdMember[${ idx }].householdIncomeOrSizeChanged`,
                                            secureValue
                                        ]
                                    ]
                                }
                            />
                        </Fragment>
                    )
                    : null
            }
        </Fragment>
    );
};

export default MedicaidTerminationDetailsInfo;